module.exports = __webpack_public_path__ + "static/media/280965.ce412dcb.png";